"use client";

import { useLanguage } from "@/lib/i18n/context";
import { useLoading } from "@/lib/loading/loading-context";
import { ScreenLoader } from "./screen-loader";

export function LoaderWrapper() {
  const { isChanging } = useLanguage();
  const { isHydrated, appLoadingTasks } = useLoading();
  
  // Show loader if we are currently changing language OR if we haven't hydrated yet OR if there are ongoing tasks
  return <ScreenLoader isVisible={isChanging || !isHydrated || appLoadingTasks > 0} />;
}
